var Codec = require('io/codec');
var BufferOutputStream = require('io/buffer-output-stream');

var util = require('content/util');
var ContentSerialiser = require('content/serialiser');

var BEES = require('serialisers/byte-encoded-enum-serialiser');
var TopicAddFailReason = require('../../../topics/topics').TopicAddFailReason;
var TopicDetailsSerialiser = require('topics/details/topic-details-serialiser');

var Status = {
    OK : 0,
    OK_CACHED : 1,
    FAILURE : 2,
    CACHE_FAILURE : 3
};

var serialiser = {
    read : function(input) {
        var status = Codec.readByte(input);
        var reason = "";

        if (status === Status.FAILURE) {
            reason = BEES.read(input, TopicAddFailReason);
        }

        return {
            status : status,
            reason : reason
        };
    },
    write : function(output, req) {
        Codec.writeString(output, req.path);

        // TODO: Topic details reference
        Codec.writeInt32(output, 0);

        TopicDetailsSerialiser.write(output, req.details);

        if (req.content) {
            Codec.writeBoolean(output, true);
            ContentSerialiser.write(output, req.content);
        } else {
            Codec.writeBoolean(output, false);
        }
    }
};

module.exports = serialiser;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/add-topic/add-topic-serialiser.js
// module id = 1000
// module chunks = 1